// celphone vertical 450px(sm)
// celphone horizontal 600px(md)
// tablet vertical 768px(lg)
// tablet horizontal 992px(xl)
// small laptops 1040px, 1160px, 1280px(xl2, xl3, xl4)
// desktop 1344px(hd)
// large screens 1552px(hd2)
// ultra large desktop display 2208px(ul)

const breakpoint = {
  xxs: '0',
  xs: '18rem', //288px
  xs2: '23rem', //368px
  sm: '28.125rem', //450px
  md: '37.5rem', //600px
  lg: '48rem', //768px
  lg2: '55rem', //880px
  xl: '62rem', //992px
  xl2: '65rem', // 1040px
  xl3: '72.5rem', // 1160px
  xl3max: '75rem', //1200px
  xl4: '80rem', //1280px
  hd: '84rem', // 1344px
  hd2: '97rem', // 1552px
  hd3: '110rem', //1760px
  hd4: '118rem', //1888px
  hd5: '128rem', //2048px
  hd6: '134rem', //2144px
  ul: '138rem'
}

export default Object.freeze(breakpoint)
